import { ApolloClient, NormalizedCacheObject } from '@apollo/client/core'
import { defineStore } from 'pinia'

import { Course } from '__generated__/Course'
import { listCourses } from '__generated__/listCourses'
import { LIST_COURSES } from '@player/courses/api/queries/listCourses'
import { ListCoursesFilter, ListCoursesSort } from '__generated__/globalTypes'

export const useCoursesStore = defineStore({
  id: 'courses',
  state: () => ({
    courses: [] as Course[],
    count: 0,
    serverError: false,
    loading: false
  }),
  getters: {},
  actions: {
    async listCourses(
      client: ApolloClient<NormalizedCacheObject>,
      filter: ListCoursesFilter,
      sort: ListCoursesSort[],
      offset: number,
      limit: number,
      startDate?: string,
      endDate?: string
    ) {
      try {

        const { data } = await client.query<listCourses>({
          query: LIST_COURSES,
          variables: {
            filter,
            sort,
            offset,
            limit,
            startDate,
            endDate
          },
          fetchPolicy: 'no-cache'
        })
        const { listCourses } = data

        // Include unauthenticated list courses error
        if (
          listCourses.__typename === 'ServerError' ||
          listCourses.__typename === 'UnauthorizedError' ||
          listCourses.__typename === 'UnauthenticatedError' ||
          listCourses.__typename === 'ListCoursesErrorOutput'
        ) {
          this.serverError = true
          return
        }
        const { courses, count } = listCourses
        this.courses = courses
        this.count = count
      } catch (e) {
        this.serverError = true
        console.error(e)
      } finally {
        this.loading = false
      }
    }
  }
})
